import { getInitials } from 'utilities/getInitials';
import { FirmIconChipProps } from './FirmIconChip.props';
import { FirmIconAvatar, FirmIconWrapper } from './Home.styles';

const FirmIconChip = ({ firm, onClick }: FirmIconChipProps) => {
  const initials = getInitials({ name: firm.name });

  return (
    <FirmIconWrapper onClick={() => onClick(firm.slug)} title={firm.name}>
      {firm.icon_url ? (
        <img
          alt={firm.name}
          src={firm.icon_url}
          style={{ display: 'block', height: '100%', objectFit: 'contain', width: '100%' }}
        />
      ) : (
        <FirmIconAvatar variant="rounded">{initials}</FirmIconAvatar>
      )}
    </FirmIconWrapper>
  );
};

export default FirmIconChip;
